import { createDefaultConfigurationApplied } from '@spotify-internal/event-definitions/es5/events/createDefaultConfigurationApplied';
import { createDefaultConfigurationAppliedNonAuth } from '@spotify-internal/event-definitions/es5/events/createDefaultConfigurationAppliedNonAuth';
import { KnownContext, } from '@spotify-internal/remote-config-core';
const createEvent = ({ context, clientId, reason, }) => {
    const authorize = Boolean(context.username);
    const eventData = {
        installation_id: context.installationId,
        rc_client_id: clientId,
        platform: 'WEB',
        fetch_type: context.fetchType,
        reason,
        identifiers: KnownContext.extractIdentifiersMap(context),
    };
    if (authorize) {
        return createDefaultConfigurationApplied(eventData);
    }
    return createDefaultConfigurationAppliedNonAuth(eventData);
};
export function errorExposureMiddleware(next) {
    return ({ clientId, eventSender }) => (context) => next(context).catch((err) => {
        const reason = hasProperty(err, 'message')
            ? String(err.message)
            : undefined;
        eventSender.send(createEvent({
            context,
            reason,
            clientId,
        }));
        throw err;
    });
}
function hasProperty(obj, name) {
    return (((typeof obj === 'object' && obj !== null) || typeof obj === 'function') &&
        name in obj);
}
//# sourceMappingURL=error-exposure.js.map